import React from "react";
import { Breadcrumb } from "../../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../../components/Buttons";

export const InProgram = () => {
    document.title = "Proqram daxili";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Ayarlar", value: "/settings" },
        { name: "Ödəniş", value: "/settings/payment" },
        { name: "Proqram daxili", value: "/settings/payment/inporgram", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Proqram daxili ödəniş qaydası</h2>
                    <p>
                        Profil balansını artırmaq üçün aşağıdakı ardıcıllığa əməl etmək lazımdır
                        <ol>
                            <li>
                                <a href={"https://bein.az"}>Bein.az</a> saytında istifadəçi profilinə daxil olduqdan sonra, düyməsini sıxın və açılan pəncərədə{" "}
                                <b>texniki dəstək</b> seçimini edin
                            </li>
                            <li>Açılan dialoq pəncərəsində Balans artır seçimini edin</li>
                            <li>
                                Növbəti mərhələdə istifadəçi, <mark>Milli Ön</mark> ödəmə sisteminə yönləndiriləcək. Qeydiyyatdan keçdiyiniz nömrəni daxil edib
                                <SaveButton>irəli</SaveButton> düyməsini sıxın
                            </li>
                            <li>
                                Ödəyəcəyiniz məbləği qeyd edib <SaveButton>irəli</SaveButton> düyməsini sıxın
                            </li>
                            <li>
                                Kart məlumatlarını daxil etmək üçün açılan pəncərədə məlumatlar daxil edilib <SaveButton>ödə</SaveButton> düyməsini sıxın
                            </li>
                        </ol>
                        <b>Qeyd</b>: Ödəniş zamanı komissiya haqqı tutulmur.
                    </p>
                    <img src="/images/settings/payment/inprogram-1.gif" alt="Proqram daxili" />

                    <h2 className="my-4">Profil Balansı haqqında</h2>
                    <p>
                        Balansı artırmaq üçün balans səhifəsində artirilacaq məbləği yazıb <Button>Ödə</Button> düyməsini sıxın. Açılmış pəncərədə məlumatları
                        yazıb ödənişi təsdiq edin. Balansınız avtomatik olaraq yenilənəcək.
                        <br />
                        <b>Qeyd</b>: Ödəniş zamanı komissiya haqqı tutulmur.
                        <br />
                        Nümunədə istifadəçinin sistemdən istifadə etmək üçün etdiyi ödənişlər və sistemdən istifadə etmək üçün günlük hesabdan çıxılan ödənişlər
                        əsasında formalaşan balansı göstərilib.
                    </p>
                    <img src="/images/settings/payment/inprogram-2.gif" alt="Proqram daxili" />
                </article>
            </div>
        </div>
    );
};
